/**
 * Les phrases que le jeu dit à l'élève quand il refuse un geste.
 *
 * Elles vivent dans `content.messages` (règle n° 2 : zéro texte en dur). Ce
 * module n'est qu'un accès nommé, pour que les refus du moteur ne manipulent
 * pas la structure du contenu.
 *
 * Auparavant ces messages étaient extraits d'entre les guillemets français de
 * `regles_moteur`, dont les champs sont rédigés comme des consignes pour la
 * personne qui implémente le jeu. Le texte affiché dépendait donc d'une
 * convention de ponctuation : reformuler une règle sans guillemets suffisait à
 * envoyer la consigne technique entière devant une classe. `regles_moteur`
 * reste la documentation des règles ; il n'est plus une source de texte.
 */
import type { Content, PlayerMessages } from './content-schema.js';

/** Le message adressé à l'élève pour un refus donné. */
export function playerMessage(content: Content, cle: keyof PlayerMessages): string {
  return content.messages[cle];
}
